import React from 'react'

const TimeTrigger = () => {
  return (
    <div>TimeTrigger</div>
  )
}

export default TimeTrigger